class Device {
  constructor() {
    this.numpad = true
  }
  _init = async () => {
    return true
  }

  properties = async () => {
    const properties = {
      mac: await __._api.getProperties("mac_address"),
      ip: await __._api.getProperties("ip_address"),
      serial: await __._api.getProperties("serial_number"),
      firmware: await __._api.getProperties("platform_version"),
      software: await __._api.getProperties("hcap_middleware_version"),
      manufacturer: await __._api.getProperties("platform_manufacturer"),
      product: await __._api.getProperties("model_name"),
      type: "hcap"
    }

    const res = Object.keys(properties).every(key => {
      return properties[key] || false
    })

    return res && properties
  }
  baseUrl = async () => {
    let promise = await _$.progress.create()
    hcap.system.getProcentricServer({
      onSuccess: payload => promise.resolve(`http://${payload.ipServer.ip || payload.ipServer.domainName}:${payload.ipServer.port}`),
      onFailure: () => promise.resolve(location.origin)
    })
    return promise.done
  }
  getKeyMap = async () => {
    return [
      // Controllers
      [hcap.key.Code.LEFT, "left"],
      [hcap.key.Code.UP, "up"],
      [hcap.key.Code.RIGHT, "right"],
      [hcap.key.Code.DOWN, "down"],
      [hcap.key.Code.ENTER, "enter"],
      [hcap.key.Code.BACK, "back"],
      [hcap.key.Code.EXIT, "exit"],
      [-1, "vol_up"],
      [-1, "vol_down"],
      [-1, "mute"],

      // Player Controller
      [hcap.key.Code.PLAY, "play"],
      [hcap.key.Code.PAUSE, "pause"],
      [-1, "toggle"],
      [hcap.key.Code.STOP, "stop"],
      [hcap.key.Code.FAST_FORWARD, "fw"],
      [hcap.key.Code.REWIND, "rw"],
      [-1, "prev"],
      [-1, "next"],

      // TV
      [hcap.key.Code.CH_UP, "ch_up"],
      [hcap.key.Code.CH_DOWN, "ch_down"],
      [hcap.key.Code.TV_RAD, "tv"], //Register
      [hcap.key.Code.SUBTITLE, "subtitle"], //Register
      [hcap.key.Code.AD, "ad"], //Register
      [hcap.key.Code.LIST, "list"], //Register
      [hcap.key.Code.GUIDE, "epg"],

      // General
      [hcap.key.Code.INFO, "info"],
      [hcap.key.Code.SEARCH, "search"], //Register
      [hcap.key.Code.MENU, "settings"], //Register
      [hcap.key.Code.ALARM, "alarm-clock"],
      [-1, "sleep-timer"],
      [hcap.key.Code.INPUT, "source"], //Register
      [-1, "power"],
      [hcap.key.Code.PORTAL, "home"], //Register
      [-1, "refresh"],

      [hcap.key.Code.RED, "red"],
      [hcap.key.Code.GREEN, "green"],
      [hcap.key.Code.YELLOW, "yellow"],
      [hcap.key.Code.BLUE, "blue"],

      // Numpad
      [hcap.key.Code.NUM_0, "numpad", 0],
      [hcap.key.Code.NUM_1, "numpad", 1],
      [hcap.key.Code.NUM_2, "numpad", 2],
      [hcap.key.Code.NUM_3, "numpad", 3],
      [hcap.key.Code.NUM_4, "numpad", 4],
      [hcap.key.Code.NUM_5, "numpad", 5],
      [hcap.key.Code.NUM_6, "numpad", 6],
      [hcap.key.Code.NUM_7, "numpad", 7],
      [hcap.key.Code.NUM_8, "numpad", 8],
      [hcap.key.Code.NUM_9, "numpad", 9],

      // Applications
      [-1, "youtube"],
      [-1, "netflix"],
      [-1, "prime"],
      [-1, "spotify"],
      [-1, "browser"],
      [-1, "cast"],
      [-1, "movies"],
      [-1, "musics"],
      [-1, "usb"]
    ]
  }
  setName = async name => {
    if (!name) return false

    const promise = await _$.progress.create()
    hcap.property.setProperty({
      key: "tv_name",
      value: name,
      onSuccess: () => promise.resolve(),
      onFailure: payload => promise.reject(payload.errorMessage)
    })
    return promise.done
  }
  getName = async () => {
    const promise = await _$.progress.create()
    hcap.property.getProperty({
      key: "tv_name",
      onSuccess: () => promise.resolve(),
      onFailure: payload => promise.reject(payload.errorMessage)
    })
    return promise.done
  }

  /* Register Methods */
  registerKeys = async () => {
    let promise = await _$.progress.create()
    hcap.key.clearKeyTable({
      onSuccess: () => promise.resolve(),
      onFailure: payload => promise.reject(payload.errorMessage)
    })
    await promise.done

    const registerKeys = [
      hcap.key.Code.TV_RAD,
      hcap.key.Code.SUBTITLE,
      hcap.key.Code.AD,
      hcap.key.Code.LIST,
      //hcap.key.Code.MENU,
      hcap.key.Code.INPUT,
      hcap.key.Code.PORTAL,
      hcap.key.Code.APPS,
      hcap.key.Code.SMART_HOME,
      hcap.key.Code.ALARM,
      hcap.key.Code.SEARCH
    ]

    registerKeys.forEach(key => {
      /* Library Code */
      hcap.key.addKeyItem({
        keycode: 0,
        virtualKeycode: key,
        attribute: 2,
        onSuccess: () => {},
        onFailure: payload => _$.error(payload.errorMessage)
      })
      /* Library Code */
    })

    return true
  }

  /* Volume Management */
  volume = async volume => {
    let promise = await _$.progress.create()

    if (typeof volume !== "number") {
      hcap.volume.getVolumeLevel({
        onSuccess: payload => promise.resolve(payload.level),
        onFailure: payload => promise.reject(payload.errorMessage)
      })
    } else {
      hcap.volume.setVolumeLevel({
        level: volume,
        onSuccess: () => promise.resolve(),
        onFailure: payload => promise.reject(payload.errorMessage)
      })
    }

    return promise.done
  }
  mute = async value => {
    if (["boolean", "number"].indexOf(typeof value) >= 0) return this.volume(value ? -1 : __.device.defaultVolume)
    return this.volume().then(volume => (volume === -1 ? true : false))
  }
  maxVolume = async () => {
    let promise = await _$.progress.create()

    hcap.property.setProperty({
      key: "maximum_volume_level",
      value: __.device.maxVolume.toString(),
      onSuccess: () => promise.resolve(),
      onFailure: payload => promise.reject(payload.errorMessage)
    })

    return promise.done
  }

  setTimeZone = async () => {
    const raw = __.device.config("lgtimezone.lgtimezone")
    const config = typeof raw === "string" ? JSON.parse(raw) : raw
    idcap.request("idcap://time/timezone/set", {
      parameters: {
        continent: config.continent,
        country: config.country,
        city: config.city
      },
      onSuccess: function() {
        console.log("onSuccess")
      },
      onFailure: function(err) {
        console.log("onFailure : errorMessage = " + err.errorMessage)
      }
    })
  }
  /* Power Management */
  getPowerState = async () => {
    let promise = await _$.progress.create()

    /* Library Code */
    hcap.power.getPowerMode({
      onSuccess: payload => promise.resolve(payload.mode),
      onFailure: payload => promise.reject(payload.errorMessage)
    })
    /* Library Code */

    return promise.done.then(res => (res === 1 ? "on" : "standby"))
  }
  powerOn = async () => {
    let promise = await _$.progress.create()

    /* Library Code */
    hcap.power.setPowerMode({
      mode: hcap.power.PowerMode.NORMAL,
      onSuccess: () => promise.resolve(),
      onFailure: payload => promise.reject(payload.errorMessage)
    })
    /* Library Code */

    return promise.done
  }
  standBy = async () => {
    let promise = await _$.progress.create()

    /* Library Code */
    hcap.power.powerOff({
      onSuccess: () => promise.resolve(),
      onFailure: payload => promise.reject(payload.errorMessage)
    })
    /* Library Code */

    return promise.done
  }
  reboot = async () => {
    let promise = await _$.progress.create()

    /* Library Code */
    hcap.power.reboot({
      onSuccess: () => promise.resolve(),
      onFailure: payload => promise.reject(payload.errorMessage)
    })
    /* Library Code */

    return promise.done
  }
  clearData = async () => {
    const promise = await _$.progress.create()
    hcap.property.setProperty({
      key: "security_level",
      value: "1",
      onSuccess: () => promise.resolve(),
      onFailure: payload => promise.reject(payload.errorMessage)
    })

    return promise.done
  }

  /* Soft AP */
  async _softAPUi() {
    const soft_ap_ui = await __._api.getProperties("soft_ap_ui").then(res => res === "1")
    if (!soft_ap_ui) await __._api.setProperties("soft_ap_ui", "1")
    return true
  }
  async getSoftAP() {
    await this._softAPUi()

    return {
      ssid: await __._api.getProperties("tv_name"),
      password: __.device.generateSoftAPPassword(),
      status: await this.isSoftAPEnabled()
    }
  }
  async enableSoftAP(ssid, password) {
    await this._softAPUi()

    const soft_ap = await __._api.getProperties("soft_ap")
    if (soft_ap === "0") await __._api.setProperties("soft_ap", "0")

    return __._api.setProperties("soft_ap_password", password).then(() => __._api.setProperties("soft_ap", "1"))
  }
  async disableSoftAP() {
    await this._softAPUi()
    return __._api.setProperties("soft_ap", "0")
  }
  async isSoftAPEnabled() {
    return __._api.getProperties("soft_ap").then(status => status === "1")
  }
}

export default Device
